// @flow
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { Box } from 'grommet';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel/actions';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';
import { isEmpty } from 'lodash';

type SidePanelActionProps = {
    closePanel: (key: string) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    id: string,
    title: React.Node,
    onClose: Function,
    onSave: Function,
    onStartDraw?: Function,
    children: React.Node,
    intl: IntlShape,
    isDrawing: boolean,
    canSave: boolean,
    closeAllOpened: boolean,
    formikRef: Object,
}

const messages = defineMessages({
    drawBtn: {
        id: 'start-draw-btn',
        defaultMessage: 'Start Draw',
    },
});

const mapDispatchToProps = (dispatch) => (bindActionCreators(
    { closePanel: closePanelAction },
    dispatch,
));

const Creator = (props: Props) => {
    const {
        title, onClose, onSave, onStartDraw: onDraw, children, intl: { formatMessage }, isDrawing,
        canSave, id, closeAllOpened, formikRef,
    } = props;

    const [canSubmitOnDraw, setCanSubmitOnDraw] = React.useState(false);

    const handleSave = () => {
        onSave();
    };

    React.useEffect(() => {
        if (formikRef && formikRef.current) {
            formikRef.current.getFormikBag().validateForm().then(() => {
                if (formikRef.current) {
                    setCanSubmitOnDraw(isEmpty(formikRef.current.getFormikBag().errors));
                }
            });
        }

        return () => {
            setCanSubmitOnDraw(false);
        };
    }, [formikRef.current, children]);

    return (
        <SidePane
            id={id}
            title={title}
            closeAllOpened={closeAllOpened}
            sensitive
        >
            <Box height="100%">
                <Box
                    direction="row"
                    align="center"
                    height="100%"
                    overflow="auto"
                    style={{ position: 'unset' }}
                >
                    <Box pad={{ horizontal: 'small' }} alignSelf="stretch" flex>
                        {children}
                    </Box>
                </Box>
                <ActionButtons
                    submitButtonLabel={isDrawing ? undefined : formatMessage(messages.drawBtn)}
                    onClose={onClose}
                    disabled={isDrawing ? !canSave : !canSubmitOnDraw}
                    onSave={isDrawing ? handleSave : onDraw}
                />
            </Box>
        </SidePane>
    );
};

Creator.defaultProps = {
    onClose: undefined,
    closeAllOpened: true,
    onStartDraw() {},
};

export default injectIntl(connect(null, mapDispatchToProps)(Creator));
